const html = document.documentElement;
const body = document.body;
const nav = document.querySelector(".navigation");
const navTrigger = document.querySelector(".navigation__trigger");
const header = document.querySelector("header");
const navBackground = document.querySelector(".navigation__background");
const logo = document.querySelector(".header__logo");
const logoBgHeight = 129;

if (navTrigger) {
  navTrigger.addEventListener("click", (e) => {
    e.preventDefault();

    if (nav.classList.contains("active")) {
      if (window.innerWidth > 640) {
        nav.classList.add("close-menu");
        if (window.pageYOffset > logoBgHeight) {
          logo.classList.remove("visible");
        }
        navBackground.addEventListener("animationend", resetMenu);
      } else {
        // logo.classList.remove('visible');
        resetMenu();
      }
    } else {
      html.classList.add("disable-jumping-scollbar");
      nav.classList.add("active");
      nav.classList.add("dark-theme");
      body.classList.add("overflow-hidden");
      logo.classList.add("visible");
      header.classList.add("overflow-visible");

      [].forEach.call(nav.querySelectorAll("li"), (item, index) => {
        let newDelay = 0.6 + index * 0.1;
        item.style.transitionDelay = `${newDelay}s`;
      });
    }
  });
}

if (nav && navBackground && logo) {
  document.onkeydown = function (evt) {
    evt = evt || window.event;
    let isEscape = false;
    if ("key" in evt) {
      isEscape = evt.key === "Escape" || evt.key === "Esc";
    } else {
      isEscape = evt.keyCode === 27;
    }
    if (isEscape) {
      nav.classList.add("close-menu");
      if (window.pageYOffset > logoBgHeight) {
        logo.classList.remove("visible");
      }
      navBackground.addEventListener("animationend", resetMenu);
    }
  };
}

function resetMenu() {
  html.classList.remove("disable-jumping-scollbar");
  nav.classList.remove("active");
  nav.classList.remove("close-menu");
  nav.classList.remove("dark-theme");
  body.classList.remove("overflow-hidden");
  header.classList.remove("overflow-visible");

  [].forEach.call(nav.querySelectorAll("li"), (item) => {
    item.removeAttribute("style");
  });

  navBackground.removeEventListener("animationend", resetMenu);
}
